module.exports = __webpack_public_path__ + "img/yjda.c499d1bd.png";